type Logger = Window['logger'];
type ConsoleMethod = 'log' | 'warn' | 'error' | 'info';

function getHostLogger(): Logger | undefined {
  return typeof window === 'undefined' ? undefined : window.logger;
}

function callHost(method: keyof Logger, params: any[]): boolean {
  const hostLogger = getHostLogger();
  const hostMethod = hostLogger?.[method];
  if (typeof hostMethod !== 'function') {
    return false;
  }
  hostMethod.apply(hostLogger, params);
  return true;
}

function write(method: ConsoleMethod, params: any[]): void {
  if (callHost(method, params)) {
    return;
  }
  globalThis.console[method](...params);
}

const logger: Logger = {
  log: (...params) => write('log', params),
  warn: (...params) => write('warn', params),
  error: (...params) => write('error', params),
  info: (...params) => write('info', params),
  track: (...params) => {
    callHost('track', params);
  }
};

export default logger;
